<template>
    <app-page-options-list 
        :options="options"
    />            
</template>
<script>
    import PageOptionsList from '../../components/UI/Controls/PageOptions/PageOptionsList.vue';
    import { mapGetters } from 'vuex';

    const BASE_OPTIONS = [
        { to: 'personVisitors', label: 'Visitas de Personas', icon: '' },
        { to: 'vehicleVisitors', label: 'Visitas de Vehículos', icon: '' },
        { to: 'PqrPage', label: 'PQR', icon: ''},
        { to: 'dutiesAdminClientPage', label: 'Consignas', icon: ''},
        { to: 'notebookAdminClient', label: 'Minutas', icon: ''},
        { to: 'listStructuresAdminClient', label: 'Estructuras', icon: ''},
        { to: 'authorizeEntryPersonListAdminClient', label: 'Autorizaciones', icon: ''},
        { to: 'reportingDashboard', label: 'Reportes', icon: ''},
        { to: 'peoplePageListClient', label: 'Personas', icon: ''},
        { to: 'vehiclesPageClient', label: 'Vehículos', icon: ''},
        { to: 'clientAreasPage', label: 'Áreas de la Empresa', icon: ''},
        { to: 'clientDataConsentPage', label: 'Tratamiento de datos', icon: ''},
        { to: 'incidentRiskTypesPage', label: 'Tipos de Incidentes y Riesgos', icon: ''},
    ];

    export default {
        components: {
            appPageOptionsList: PageOptionsList
        },
            computed: {
            ...mapGetters(['client', 'user']),
            options() {
                const slug = this.user && this.user.profile ? this.user.profile.slug : '';
                const contractorExtras = [];
                if (this.clientHasContractorModule) {
                    contractorExtras.push({ to: 'contractorDocumentTypesPage', label: 'Tipos de documento contratista', icon: '' });
                    contractorExtras.push({ to: 'contractorManagementPage', label: 'Gestión de Contratista', icon: '' });
                }
                if (slug === 'sst') {
                    return [...contractorExtras];
                }

                const list = [...BASE_OPTIONS];
                contractorExtras.forEach((opt) => list.push(opt));

                return list;
            },
            clientHasContractorModule() {
                const client = this.client;
                if (!client || !client.id) return false;
                let modules = client.optional_modules || client.optionalModules;
                if (!modules || !Array.isArray(modules)) {
                    const userClients = this.user && (this.user.clients || this.user.clients_list);
                    if (userClients && Array.isArray(userClients)) {
                        const sameClient = userClients.find(c => c.id === client.id);
                        modules = sameClient && (sameClient.optional_modules || sameClient.optionalModules);
                    }
                }
                if (!modules || !Array.isArray(modules)) return false;
                return modules.some(m => m && (m.slug === 'contractor' || (m.slug && m.slug.toLowerCase() === 'contractor')));
            }
        }
    }
</script>